// UUID encoding and decoding utility functions
export const encodeWithSalt = (data, salt) => {
  const json = JSON.stringify(data);
  const salted = salt + json + salt;
  return btoa(salted); // base64_encode equivalent in JavaScript
};

export const decodeWithSalt = (encoded, salt) => {
  const decoded = atob(encoded); // base64_decode equivalent in JavaScript
  const json = decoded.replace(new RegExp(salt, 'g'), '');
  return JSON.parse(json);
};

// Default salt value - updated as per user request
export const DEFAULT_SALT = "BriGizProdAPI"; 